module.exports = __webpack_public_path__ + "img/score3.4bf556ee.png";